import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, OAuthProvider, FacebookAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyABRcpQasu7HL7L03BxWt-WavBROHvw9Vk",
  authDomain: "risk-ready-140a6.firebaseapp.com",
  projectId: "risk-ready-140a6",
  storageBucket: "risk-ready-140a6.appspot.com",
  messagingSenderId: "1007915442433",
  appId: "1:1007915442433:web:61bb9dd056454fda757b00",
  measurementId: "G-Y25NKDBFW8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth();
auth.languageCode = "en";
const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: "select_account" });

const fbProvider = new FacebookAuthProvider();
fbProvider.setCustomParameters({
  display: "popup",
});

const appleProvider = new OAuthProvider("apple.com");
appleProvider.setCustomParameters({
  locale: "en",
});

const db = getFirestore(app);

export { auth, provider, fbProvider, db, storage };
